import { MARKETPLACE_ACCESS_CONTROL_SUB_ROUTE } from '@agilelab/plugin-wb-access-control';

export const DataProductPageRoutes = {
  OVERVIEW_ROUTE: '',
  DATA_CONTRACTS_LINEAGE: '/data-contracts',
  REVIEWS_ROUTE: '/reviews',
  RELATIONS_ROUTE: '/dependencies',
  QUESTIONS_ROUTE: '/questions',
  OBSERVABILITY_ROUTE: '/observability',
  CONTROL_CENTER: MARKETPLACE_ACCESS_CONTROL_SUB_ROUTE,
  DOCS: '/docs',
};
